import { render, staticRenderFns } from "./DialogPageRelatedChats.vue?vue&type=template&id=6e896bd0"
import script from "./DialogPageRelatedChats.vue?vue&type=script&lang=js"
export * from "./DialogPageRelatedChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports